import './assets/scss/main.scss'
import './assets/fonts/icons.css'
import { createApp, defineAsyncComponent } from 'vue'
import AppConfig from './js/AppConfig'
import ScrollToTop from './components/ScrollToTop.vue'
//import FlagButton from './components/FlagForm/FlagButton.vue'
//import FlagFormContainer from './components/FlagForm/FlagFormContainer.vue'
import VoteBox from './components/VoteBox.vue'
//const VideoPlayer = () => import('./components/VideoPlayer.vue');
//import VideoPreview from './components/VideoPreview.vue'
import Rotator from './js/Rotator'
import { watch as galleryWatch } from './js/GalleryRotatorWatch'

createApp({
  components: {
    ScrollToTop,
    GallerySlider: defineAsyncComponent(() => import('@/components/LightGallery/GallerySlider.vue')),
    //FlagButton,
    //FlagFormContainer,
    VoteBox,
    //VideoPreview,
    //VideoPlayer
  }
}).mount('#app')

if (AppConfig.videoRotator.enabled) {
  Rotator.configure(AppConfig.videoRotator)
  Rotator.run()
}

if (AppConfig.galleryRotator.enabled) {
  galleryWatch()
}
